import { View } from '@react-pdf/renderer'
import ReactPDFChart from 'react-pdf-charts'
import { Bar, BarChart, Legend, XAxis, YAxis } from 'recharts'
import { tw } from '~/components/pdfs'

export type ChartBarConfig = {
  dataKey: string
  fill: string
  name: string
}

export type CompChartConfig = {
  bars: ChartBarConfig[]
  yAxisWidth?: number
  yAxisFormatter?: (value: number) => string
}

export type CompChartProps = {
  data: Record<string, any>[]
  config: CompChartConfig
}

export function CompChart({ data, config }: CompChartProps) {
  const chartData = data.map((item, index) => ({
    name: index + 1,
    ...item,
  }))

  const maxChartWidth = 564
  const radiuses: [number, number, number, number] =
    chartData.length > 20 ? [1, 1, 0, 0] : [2, 2, 0, 0]

  const defaultYAxisFormatter = (value: number) => `$${value}`

  return (
    <View>
      <ReactPDFChart style={tw('font-sans')} chartStyle={tw('font-sans')}>
        <BarChart
          width={maxChartWidth}
          height={200}
          data={chartData}
          barGap={1}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
          {config.bars.map((bar) => (
            <Bar
              key={bar.dataKey}
              isAnimationActive={false}
              dataKey={bar.dataKey}
              fill={bar.fill}
              name={bar.name}
              radius={radiuses}
            />
          ))}
          <YAxis
            width={config.yAxisWidth || 60}
            fontSize={10}
            tickFormatter={config.yAxisFormatter || defaultYAxisFormatter}
          />
          <XAxis dataKey="name" fontSize={10} />
          <Legend style={{ marginTop: 0 }} fontSize={10} />
        </BarChart>
      </ReactPDFChart>
    </View>
  )
}
